<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-btn type="submit" color="success" class="mr-4" @click.prevent="gotoLogin">重新登入</v-btn>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  created() {
    this.clearToken();
  },
  methods: {
    ...mapActions({
      clearToken: 'token/clearToken',
    }),
    async gotoLogin() {
      await this.$router.push({ name: 'login' });
    },
  },
};
</script>
